export default class ModalPopup {
  constructor() {
    this.body = document.querySelector("body");

    // モーダルエリア作成
    this.area = document.createElement("div");
    this.area.setAttribute("id", "modal-area");
    this.body.appendChild(this.area);

    // マスク作成
    this.mask = document.createElement("div");
    this.mask.setAttribute("id", "modal-mask");
    this.area.appendChild(this.mask);
    this.mask.addEventListener("click", () => this.closeModal());

    // コンテナ作成
    this.container = document.createElement("div");
    this.container.setAttribute("id", "modal-container");
    this.area.appendChild(this.container);

    // クローズボタン作成
    this.closeButton = document.createElement("div");
    this.closeButton.setAttribute("id", "modal-close");
    this.cross = document.createElement("div");
    this.cross.setAttribute("id", "modal-cross");
    this.closeButton.appendChild(this.cross);
    this.container.appendChild(this.closeButton);
    this.closeButton.addEventListener("click", () => this.closeModal());

    this.contents = []; // 複数モーダルに対応
    this.currentIndex = null; // 表示中のモーダルのインデックス
  }

  init(MODAL, INDEX) {
    const trigger = MODAL.querySelector(".modal-trigger");
    const content = MODAL.querySelector(".modal-content");

    if (!trigger || !content) {
      console.error("Trigger or content not found in:", MODAL);
      return;
    }

    content.style.display = "none";

    const cloned = content.cloneNode(true);
    cloned.style.display = "none"; // 初期は非表示
    this.container.appendChild(cloned);
    this.contents[INDEX] = cloned;

    trigger.dataset.modalTrgIndex = INDEX;
    trigger.addEventListener("click", (event) => this.openModal(event));
  }

  openModal(event) {
    const index = event.currentTarget.dataset.modalTrgIndex;
    const modalContent = this.contents[index];

    if (!modalContent) {
      console.error("No modal content found for index:", index);
      return;
    }

    this.body.style.overflow = "hidden";
    modalContent.style.display = "block";
    this.area.classList.add("is-active");
    this.currentIndex = index;
  }

  closeModal() {
    if (this.currentIndex === null) return;

    const modalContent = this.contents[this.currentIndex];
    if (modalContent) {
      modalContent.style.display = "none";
    }

    this.body.style.overflow = "initial";
    this.area.classList.remove("is-active");
    this.currentIndex = null;
  }
}
